<template>
  <grid :config="{searchFields: ['username', 'name']}" :data="organisations"
        class="u-1-of-1">
    <template v-slot:gridAdd>
      <router-link class="c-button c-button--secondary c-button--large c-button--icon" exact
                   :to="{ name: 'admin.organisation.add'}">
        <svg role="img" class="c-button__icon">
          <use xlink:href="images/svg-symbols.svg#plus-icon"></use>
        </svg>
        <span class="c-button__label">{{$t("organisation.add")}}</span>
      </router-link>
    </template>
    <template v-slot:gridHeader>
      <div class="o-layout c-list__row u-padding-horizontal-small">
        <div class="o-layout__item u-2-of-4-at-small">
          {{$t('name')}}
        </div>
        <div class="o-layout__item u-1-of-4-at-small">
          {{$t('country')}}
        </div>
        <div class="o-layout__item u-1-of-4-at-small">
          {{$t('events')}}
        </div>
      </div>
    </template>
    <template v-slot:gridData="{element}">
      <div class="o-layout__item u-2-of-4-at-small c-list__main-cell">
        <router-link class="c-list__link" :to="{ name: 'organisation.events', params: { organisationId: element.id}}">
          {{element.name}}
        </router-link>
      </div>
      <div class="o-layout__item u-1-of-4-at-small c-list__main-cell">
        {{element.country}}
      </div>
      <div class="o-layout__item u-1-of-4-at-small c-list__main-cell">
        {{element.events}}
      </div>
    </template>
  </grid>
</template>

<script>
  import sortBy from 'lodash/sortBy'

  export default {
    name:'organisationList',
    components: {
      grid: require('client/components/dataGrid.vue').default,
    },
    computed: {
      countries: function() {
        return this.$store.state.countries.items
      },
      organisations: function() {
        return sortBy(this.$store.state.organisations.items, ['name']).map(org => {
          // count organisation events and invoiced status
          const events = this.$store.state.events.items.filter(e => e.organisationId === org.id && ! e.invoice)

          return {
            id: org.id,
            name: org.name,
            country: this.$t(org.countryId),
            events: events.length || '',
          }
        })
      }
    },
    methods: {
    },
  }
</script>
